import React, { useState } from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import DynamicForm from '../../../../components/FormElements/DynamicForm/index'
import { Col, Radio, Row, Spin } from 'antd'
import { Colors } from '../../../../config'
import LocationPicker from '../../../../components/LocationPicker'
import { AdImagePicker } from './adImagePicker'
import TextPicker from './textPicker'
import dayjs from 'dayjs'
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux'
import { setError, setMessage } from '../../../../store/common/generalSlice'
import { longitude } from '../../../../config/utils/constants'
import { useMutation } from 'react-query'
import axiosInstance from '../../../../config/api'
import { useNavigate } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import { cardImageSelector } from '../../../../config/utils/CardImageSelector'
import PromoCode from './promoCode'
import TotalAdCost from './totalAdCost'
import FullPageLoader from '../../../../components/FullPageLoader'
import Button from '../../../../components/FormElements/Button'
import PaymentCardsSelection from './paymentCardSelection'

const CreateAd = () => {

    const [isError, setIsError] = useState(false);
    const [data, setData] = useState(null);
    const [customLoading, setCustomLoading] = useState(false);
    const [adSumbitLoading, setAdSubmitLoading] = useState(false);

    const { profileData } = useSelector(state => state?.setting);
    const [fieldsDisabled, setFieldsDisabled] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const form = {
        name: 'adForm',
        formFields: [
            {
                name: 'image',
                type: 'custom',
                label: { value: '', style: '', classes: '' },
                width: { md: 24, sm: 24, xs: 24 },
                component: <AdImagePicker isError={(isValid) => setIsError(isValid)} disabled={fieldsDisabled} />,
            },
            {
                name: 'redirectionUrl',
                type: 'text',
                label: { value: 'Redirection URL', style: '', classes: '' },
                width: { md: 12, sm: 24, xs: 24 },
                disabled: fieldsDisabled
            },
            {
                name: 'date',
                type: 'datepicker',
                label: { value: 'Date', style: '', classes: '' },
                width: { md: 12, sm: 24, xs: 24 },
                classes: 'w-full h-11 date-box-shadow',
                disabled: fieldsDisabled
            },
            {
                name: 'location',
                type: 'custom',
                label: { value: 'Location', style: '', classes: '' },
                width: { md: 24, sm: 24, xs: 24 },
                component: <LocationPicker disabled={fieldsDisabled} />
            },
            // {
            //     name: 'comments',
            //     type: 'custom',
            //     label: { value: '', style: '', classes: '' },
            //     width: { md: 24, sm: 24, xs: 24 },
            //     component: <TextPicker />
            // },
            {
                name: 'promoCodeId',
                type: 'custom',
                label: { value: 'Promo code', style: '', classes: '' },
                width: { md: 12, sm: 24, xs: 24 },
                component: <PromoCode />
            },
            {
                name: 'adTotal',
                type: 'custom',
                label: { value: '', style: '', classes: '' },
                width: { md: 24, sm: 24, xs: 24 },
                component: <TotalAdCost />
            },
        ],
        formValidation: {
            redirectionUrl: Yup.string().required(),
            date: Yup.date()
                .required("Date is required")
                .test("future-date", "Date must be in the future", (value) => {
                    return value && dayjs(value).isAfter(dayjs(), "day"); // Ensures the selected date is after today
                }), 
            location: Yup.object().required()
        }
    }

    const adMutation = useMutation(async (formData) => {
        setAdSubmitLoading(true)
        let resp = await axiosInstance.post('/user/advertisement-web', formData);
        return resp
    },
        {
            onSuccess: (resp) => {
                dispatch(setMessage(resp?.data?.data?.message));
                navigate('/settings')
                setAdSubmitLoading(false)
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
                setAdSubmitLoading(false)
            }
        }
    )

    const handleSubmit = (data) => {
        if (!isError) {
            const { image, redirectionUrl, location, comment, date } = data;
            if (!image) {
                dispatch(setError('Image is required'));
                return
            }
            
            let dateString = dayjs(date).format('YYYY-MM-DD');

            let payload = {
                image,
                date: dateString,
                redirectionUrl,
                email: profileData?.email,
                latitude: location?.lat,
                longitude: location?.lng,
                postalCode: location?.postalCode ? location.postalCode : '',
                town: location?.town ? location.town : '',
                addressLine1: location?.address ? location.address : '',
                addressLine2: location?.address ? location.address : '',
                // comment: comment ? comment : '',
                promoCodeId: data?.promoCodeId?.id ? data?.promoCodeId?.id : '',
                discount: data?.promoCodeId?.discount ? data?.promoCodeId?.discount : ''
            }
            setCustomLoading(true)
            setTimeout(() => {
                setCustomLoading(false)
                setFieldsDisabled(true)
                setData(payload)
            }, [1000])
        }
    }

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const cardSelectionHandler = (cardId) => {
        if (data && cardId) {
            let payload = {
                ...data,
                paymentMethodId: cardId
            }
            setData(payload)
            const formData = new FormData();
            for (const key in payload) {
                formData.append(key, payload[key])
            }
            adMutation.mutate(formData)
        }
    }

    return (
        <div className='w-full flex flex-col gap-3'>
            <TitleWithBackNavigation title={"Create Ad"} link={'/settings'} />
            <Row className='w-full my-3 bg-white rounded-md custom--boxShadow py-4 px-2'>
                <Row className='max-w-[800px] w-full rounded-md mx-auto p-3 flex items-center'>
                    <DynamicForm
                        form={form}
                        onSubmit={handleSubmit}
                    />
                    {
                        !data &&
                        <Col span={24} className="flex items-center justify-center ">
                            <Button.Basic
                                onClick={submitForm}
                                loading={customLoading}
                                className='w-36 h-10 mt-3 rounded-md outline-none border-none bg-[#fab700] text-white ad-btn'
                                text={'Save'}
                            />
                        </Col>
                    }

                    {
                        customLoading && <FullPageLoader />
                    }
                    {
                        !customLoading && data && <PaymentCardsSelection cardSelectionHandler={cardSelectionHandler} adSumbitLoading={adSumbitLoading} />
                    }
                </Row>
            </Row>


        </div>
    )
}

export default CreateAd
